(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["infinite-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.querySelector('.carousel-alt');
    const items = Array.from(carousel.children);
    const itemCount = items.length;
    let currentIndex = 0;
    let isAnimating = false;
    const slidesToShow = 2;
    const speed = 10000; // total time for one full scroll (ms)
    const stepTime = 20; // ms per animation frame
    const stepPx = 1; // px per frame

    // Set up carousel container for horizontal scroll
    carousel.style.display = 'flex';
    carousel.style.overflow = 'hidden';
    carousel.style.visibility = 'visible';
    carousel.style.scrollBehavior = 'auto';

    // Clone items for infinite effect
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      carousel.appendChild(clone);
    });

    let scrollAmount = 0;
    function autoScroll() {
      if (!isAnimating) return;
      carousel.scrollLeft += stepPx;
      scrollAmount += stepPx;
      // When scrolled past original items, reset
      if (scrollAmount >= carousel.scrollWidth / 2) {
        carousel.scrollLeft = 0;
        scrollAmount = 0;
      }
      setTimeout(autoScroll, stepTime);
    }

    function startAutoScroll() {
      isAnimating = true;
      autoScroll();
    }
    function stopAutoScroll() {
      isAnimating = false;
    }

    // Start auto-scrolling
    startAutoScroll();

    // Optional: Pause on hover
    carousel.addEventListener('mouseenter', stopAutoScroll);
    carousel.addEventListener('mouseleave', startAutoScroll);
  });

  } catch(e) { console.error(e); }
})();
})();
